"use client";

import { useEffect, useRef, useState } from "react";

export function useContentTruncation<T extends HTMLElement>({
  lineHeightPx,
  lineClampLines,
  maxHeight,
}: {
  lineHeightPx: number;
  lineClampLines?: number;
  maxHeight?: number;
}) {
  const contentRef = useRef<T>(null);

  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [isTogglable, setIsTogglable] = useState<boolean | null>(null);

  useEffect(() => {
    const measureContent = () => {
      if (!contentRef.current) return;

      if (maxHeight) {
        return setIsTogglable(contentRef.current?.clientHeight > maxHeight);
      }

      if (lineClampLines) {
        const numberOfLines = contentRef.current?.clientHeight / lineHeightPx;
        setIsTogglable(numberOfLines > lineClampLines);
      }
    };

    measureContent();

    window.addEventListener("resize", measureContent);
    return () => window.removeEventListener("resize", measureContent);
  }, []);

  return {
    contentRef,
    isCollapsed,
    isTogglable,
    toggleCollapsed: () => setIsCollapsed((prev) => !prev),
  };
}
